module.exports = __webpack_public_path__ + "media/images/story/top/point_3-fd47e205e64a66e0a02173ba0225d529.svg";